module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cropperActive),
      expression: "!cropperActive"
    }],
    staticClass: "drop-zone dz-clickable",
    style: (_vm.dropzoneAreaStyle),
    attrs: {
      "id": 'dropzone-' + _vm._uid,
      "data-upload-path": "/api/admin/crop",
      "data-image-previews": "id"
    }
  }, [_c('div', {
    staticClass: "dz-message",
    style: (_vm.dropzoneMessageStyle)
  }, [_vm._v("\n      " + _vm._s(_vm.uploadMessage) + "\n    ")])]), _vm._v(" "), (_vm.cropperActive) ? _c('div', {
    staticClass: "crop",
    attrs: {
      "id": 'cropper-' + _vm._uid
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": "images/img-placeholder.png",
      "alt": "Cropbox",
      "id": 'cropbox-' + _vm._uid
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-holder"
  }, [_c('button', {
    staticClass: "m5 btn btn-accent crop-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.crop
    }
  }, [_c('i', {
    staticClass: "fa fa-crop"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.rotate(45)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-rotate-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.rotate(-45)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-rotate-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.scaleX(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.scaleX(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.scaleY(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.scaleY(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })]), _vm._v(" "), _c('button', {
    staticClass: "m5 btn btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323a74be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/ImageCropper.vue
// module id = 2140
// module chunks = 1